module.exports = __webpack_public_path__ + "db5de5bfa2a0431b58a7afb894ccbbc7.svg";